import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare const require: any;
const { version } = require('../package.json');

Sentry.init({
  dsn: "https://757f0b6dd1079170d1f513a3b674e5e0@o4511075518054400.ingest.de.sentry.io/4511075520544848",
  release: `toqqer-web@${version}`,
  environment: environment.production ? 'production' : 'development',
  enabled: environment.production,
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration({
      enableLongTask: true,
      enableInp: true,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false,
      mask: ['.login-form', '.payment-form', '.otp-input', '[type="password"]', '[type="tel"]'],
    }),
  ],
  // Performance: capture 20% of all page loads/navigations
  tracesSampleRate: 0.2,
  // Capture 100% of errors
  sampleRate: 1.0,
  // Session Replay: 10% of normal sessions, 100% of sessions with errors
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Ignore common non-actionable errors
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error promise rejection captured',
    'Loading chunk',
    'ChunkLoadError',
  ],
});

if (environment.production) {
  enableProdMode();
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
